<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @openAddDialog="updateInfo()"
      :submitService="submitService"
      addShowPower="/tatfee/add"
      :submitData="submitData"
      @success="onSuccess"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="支付类型">
        <el-select v-model="formModel.payType">
          <el-option
            v-for="item in payTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="通道名称">
        <el-select v-model="formModel.chnId" filterable>
          <el-option
            v-for="item in topchnNameList"
            :key="item.id"
            :label="item.chnName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="路线代码" v-if="formModel.chnId">
        <el-select v-model="formModel.lineCode" filterable>
          <el-option
            v-for="item in lineCodeList"
            :key="item.id"
            :label="item.shortName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="formModel.state">
          <el-option
            v-for="item in states"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatSimpleId"
        label="机构简称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="chnCode"
        label="通道代码"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
        v-if="!isTOngDao"
      ></el-table-column>
      <el-table-column
        prop="lineCode"
        label="路线代码"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="chnName"
        label="通道名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterEnable"
      ></el-table-column>
      <el-table-column
        prop="payType"
        label="支付方式"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="repayAmt"
        label="代付费（元）"
        min-width="110"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="feeAmt"
        label="费率（%）"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      >
        <template slot-scope="scope">
          <p>{{ toDoubleThousands(scope.row.feeAmt) }}</p>
        </template>
      </el-table-column>
      <el-table-column
        prop="weight"
        label="权重"
        min-width="100"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="updateTime"
        label="操作时间"
        min-width="160"
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        label="操作"
        min-width="160"
        v-if="
          hasPerm('/tatfee/udpStatus') ||
          hasPerm('/tatfee/edit') ||
          hasPerm('/tatfee/delete')
        "
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="updateInfo(scope.row.id)"
            v-if="hasPerm('/tatfee/edit')"
            >修改</el-button
          >
          <el-button
            type="text"
            @click="Disabled(scope.row.id, scope.row.status)"
            class="button-color"
            v-if="hasPerm('/tatfee/udpStatus')"
          >
            {{ scope.row.status == 1 ? "禁用" : "启用" }}
          </el-button>
        </template>
      </el-table-column>
    </common-table>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import EnableStatus from "service/constant/EnableStatus";
import ElFormItem from "element-ui/packages/form/src/form-item";

import OrganService from "service/OrganService";
import ChannelService from "service/ChannelService";
import ChannelRateService from "service/ChannelRateService";
import OrganRateService from "service/OrganRateService";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "organrate",
  data() {
    return {
      all: [
        {
          id: "",
          simpleName: "全部",
        },
      ],
      all2: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      allChnName: [
        {
          id: "",
          chnName: "全部",
        },
      ],
      allShortName: [
        {
          id: "",
          shortName: "全部",
        },
      ],
      states: EnableStatus,
      payTypes: [],
      feeTypes: [],
      settleTypes: [],
      Settlements: [],
      chnNameList: [],
      topchnNameList: [],
      lineCodeList: [],
      shortNames: [],
      formModel: {
        tatSimpleId: "",
        chnId: "",
        lineCode: "",
        payType: "",
        settleType: "",
        feeType: "",
        state: "",
      },
      tableData: [],
      submitService: OrganRateService.list,
      params: {},
      page: {},
      isPage: false,
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    ElFormItem,
    CommonTopForm,
    CommonTable,
    SelectOrgans,
  },
  mounted() {
    this.getchnNameList();
    this.getShortNames();

    this.getTypeNames("feeType", (res) => {
      this.feeTypes = [...this.all2, ...res];
    });

    this.getTypeNames("settleType", (res) => {
      this.settleTypes = [...this.all2, ...res];
    });

    this.getTypeNames("payType", (res) => {
      this.payTypes = [...this.all2, ...res];
    });
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  computed: {
    isTOngDao() {
      return this.roleTOngDao.indexOf(this.userInfo.userName) > -1;
    },
    submitData() {
      this.params = {
        tatSimpleId: this.formModel.tatSimpleId,
        chnId: this.formModel.chnId,
        payType: this.formModel.payType,
        settleType: this.formModel.settleType,
        feeType: this.formModel.feeType,
        status: this.formModel.state,
        lineCode: this.formModel.lineCode,
        userId: this.userId,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };
      return this.params;
    },
    ...mapGetters(["serverType", "tatId", "userId", "userInfo"]),
  },
  watch: {
    "formModel.chnId"(val, oldVal) {
      if (!val) {
        this.formModel.lineCode = "";
      }
      this.getLineCode(val);
    },
  },
  methods: {
    getLineCode(val) {
      this.doLoad(
        ChannelRateService.getByChn,
        {
          chnId: val,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.lineCodeList = [
              {
                id: "",
                shortName: "全部",
              },
              ...res.contents,
            ];
          });
        },
        "信息获取失败"
      );
    },
    getchnNameList() {
      this.doLoad(
        ChannelService.names,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.chnNameList = res.contents;
            this.topchnNameList = [...this.allChnName, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    getShortNames() {
      this.doLoad(
        ChannelRateService.shortNames,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.shortNames = [...this.allShortName, ...res.contents];
          });
        },
        "信息获取失败"
      );
    },
    updateInfo(id) {
      this.$router.push({
        name: "addorganrate",
        params: {
          id: id,
        },
      });
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        OrganRateService.list,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      this.doCheck(data, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    doDisabled(id) {
      const disabledParams = {
        id: id,
        userId: this.userId,
        status: this.status,
      };
      this.doLoad(
        OrganRateService.dpstatus,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    doDelete(id) {
      const disabledParams = {
        id: id,
      };
      this.doLoad(
        OrganRateService.del,
        disabledParams,
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.showSuccess(result.optMsg);
            this.getList();
          });
        },
        "操作失败"
      );
    },
    Disabled(id, type) {
      if (type == 0) {
        this.status = 1;
        this.showMsg = "确定启用此机构费率？";
      } else if (type == 1) {
        this.status = 0;
        this.showMsg = "确定禁用此机构费率？";
      } else if (type == 2) {
        this.showMsg = "确定删除此机构费率？";
      }
      this.showConfirm(this.showMsg)
        .then(() => {
          type == 2 ? this.doDelete(id) : this.doDisabled(id);
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/view/page/OrganizationManage/OrganRate.vue